/* eslint-disable react/prop-types */
import * as React from 'react';

import { translate } from '~l10n/client';
import _ from 'underscore';

import { roomsKeys } from '~teacher/hook/room/roomsKeys';
import { queryClient } from '~teacher/queryClient';
import AddIcon from 'AddIcon';
import platform from 'Platform';
import StudentEntryView from 'StudentEntryView';

let c = null;
let m = null;

export default class AddNewStudentsView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorNotify: false,
      modalClass: '',
      maxModalHeight: 'auto',
      newStudents: this.props.model.newStudents,
    };
  }

  componentDidMount() {
    this.calculateModalSize();
    window.addEventListener('orientationchange', this.calculateModalSize);
  }

  componentDidUpdate() {
    this.calculateModalSize();
  }

  componentWillUnmount() {
    window.removeEventListener('orientationchange', this.calculateModalSize);
  }

  calculateModalSize() {
    let w = Math.max(window.innerWidth || 200);
    let h = Math.max(window.innerHeight || 200);
    let modalWrapper = document.getElementById('modal-wrapper');
    let modalContent = document.getElementById('modal-content');
    let entry = 60;

    if (w <= 768) {
      entry = 195;
    }

    // Just always do full height for this terrible modal
    modalWrapper.setAttribute('class', 'full-height');
    modalContent.style.height = h - 40 + 'px';
  }

  render() {
    c = this.props.controller;
    m = this.props.model;

    return (
      <div className="add-students-list-container">
        <div
          className="modal-errors-container"
          style={{
            display: this.state.errorNotify ? 'block' : 'none',
          }}
        >
          <i data-icon="&" />
          <strong>{translate('Missing Student Information')}</strong>
        </div>
        <div className="form">
          {this.state.newStudents.map((student, index) => (
            <StudentEntryView
              key={index}
              disableListIndex={this.state.newStudents.length === 1}
              studentData={student}
              deleteNewStudent={(index) => {
                let newStudents = c.removeNewStudent(index);
                this.setState({
                  newStudents: newStudents,
                });
              }}
              {...this.props}
            />
          ))}
        </div>
        <div
          className={
            platform.browser === 'IE'
              ? 'add-students-buttons clearfix modal-footer ie-browser'
              : 'add-students-buttons clearfix modal-footer'
          }
        >
          <a
            style={{
              display:
                platform.isMobile() && !platform.isTablet ? 'none' : 'block',
            }}
            className="align-left add-another-student"
            disabled={this.state.newStudents.length === m.maxStudents}
            onClick={() => {
              let newStudents = c.addOneNewStudent();
              this.setState({
                newStudents: newStudents,
              });
            }}
          >
            <AddIcon />
            <span>{translate('Add Another')}</span>
          </a>
          <button
            className="button button-secondary-common button-large align-right"
            onClick={c.closePopup}
          >
            {translate('Cancel')}
          </button>
          <button
            className="button button-secondary button-large align-right"
            onClick={() => {
              let newStudents = c.saveNewStudents(this.props.roomId);

              let activeErrors = _.filter(newStudents, (student) => {
                return !_.isEmpty(student.errors);
              });

              if (activeErrors.length > 0) {
                this.setState({
                  errorNotify: true,
                  newStudents: newStudents,
                });

                setTimeout(() => {
                  this.setState({
                    errorNotify: false, // Remove the top banner after 2 seconds.
                  });
                }, 2000);
              }

              queryClient.invalidateQueries(roomsKeys.list());
            }}
          >
            {translate('Save')}
          </button>
        </div>
      </div>
    );
  }
}
